module.exports = __webpack_public_path__ + "static/art6-c4ac9d3b186fc258bb623da0f9f7f427.jpg";